module.exports = __webpack_public_path__ + "static/media/title-background.c33b4d3b.jpg";